import { render, staticRenderFns } from "./Dext5Editor.vue?vue&type=template&id=6ca985ca&scoped=true"
import script from "./Dext5Editor.ts?vue&type=script&lang=ts&external"
export * from "./Dext5Editor.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca985ca",
  null
  
)

export default component.exports